import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import unescapedText from 'I18n/utils/unescapedText';
import FilterToggleGroup from 'marketplace-ui-common/filters/components/filterToggleGroup/FilterToggleGroup';
import * as AssetBaseQueryField from 'marketplace-ui-assets-core/constants/AssetBaseQueryField';
const ALL_OFFERING_TYPES_VALUE = '__ALL_OFFERING_TYPES__';
let cachedOptions;

const getOptions = () => {
  if (!cachedOptions) {
    cachedOptions = [{
      value: ALL_OFFERING_TYPES_VALUE,
      text: unescapedText('marketplace-assets-ui.assets.filters.offeringType.all')
    }, {
      value: 'THEME',
      text: unescapedText('marketplace-assets-ui.assets.filters.offeringType.themes')
    }, {
      value: 'MODULE',
      text: unescapedText('marketplace-assets-ui.assets.filters.offeringType.modules')
    }];
  }

  return cachedOptions;
};

const OfferingTypeFilter = ({
  disabled,
  name,
  onChange,
  value
}) => {
  const handleOnChange = useCallback(event => {
    const eventValue = event.target.value;
    const newValue = eventValue === ALL_OFFERING_TYPES_VALUE ? [] : [eventValue];
    onChange(AssetBaseQueryField.OFFERING_TYPES, newValue);
  }, [onChange]);
  const filterValue = useMemo(() => {
    if (Array.isArray(value) && !value.length) {
      return ALL_OFFERING_TYPES_VALUE;
    }

    return value;
  }, [value]);
  return /*#__PURE__*/_jsx(FilterToggleGroup, {
    ariaLabel: unescapedText('marketplace-assets-ui.assets.filters.offeringType.title'),
    disabled: disabled,
    multi: false,
    name: name || AssetBaseQueryField.OFFERING_TYPES,
    onChange: handleOnChange,
    options: getOptions(),
    value: filterValue || ALL_OFFERING_TYPES_VALUE
  });
};

export default OfferingTypeFilter;